import {
  BlogComponentBlogItemDiv,
  BlogComponentBlogsDiv,
  BlogComponentHeroMainDiv,
  BlogComponentMainDiv,
} from "../../styles/blogcomponentstyles/blocomponentstyles";
import Footer from "../reusable/footer/footer";
import ButtonComponent from "../reusable/header/assetes/buttoncomponents/butttoncomponent";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import HeaderComponent from "../reusable/header/header";
import Logo from "./assets/bugzi logo 2.png";
const BlogComponent = () => {
  return (
    <BlogComponentMainDiv>
      <div className="header-holder">
        <HeaderComponent />
      </div>
      <BlogComponentHeroMainDiv>
        <div>
          <div className="blog-hero-container">
            <div className="blog-hero-header-container">
              <div>
                <div>
                  <HeaderSpan text="Blog" />
                </div>
              </div>
              <div>
                <div className="blog-hero-header-text-container">
                  <h1>Stay on the top of Industry News</h1>
                </div>
              </div>
            </div>
            <div className="blogs-featured-container">
              <div className="blogs-featured-wrapper">
                <div className="blog-featured-right">
                  <div className="blog-featured-right-heder-container">
                    <div className="blog-featured-header-text-wrapper">
                      <div>
                        <div className="blog-featured-contrast-text-wrapper  ">
                          <p>featured</p>
                        </div>
                      </div>
                      <div>
                        <div className="blog-featured-text-wrapper ">
                          <h2>Building Long-Lasting Customer in SaaS</h2>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="blog-featured-text-wrapper">
                        <p>
                          {" "}
                          Tailor your site’s design to meet your financial
                          targets. Easily adjust layouts, colors, and fonts to
                          match your brand without extra cost.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="blog-featured-button-wrapper">
                    <ButtonComponent title="Read More" />
                  </div>
                </div>
                <div className="blog-featured-image-container">
                  <div className="blog-featured-image-wrapper">
                    <img alt="" src={Logo} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlogComponentHeroMainDiv>
      <BlogComponentBlogsDiv>
        <div>
          <div className="blogs-container">
            <div>
              <div>
                <h2>All blogs</h2>
              </div>
            </div>
            <div>
              <div className="blogs-wrapper">
                {data.map((item, index) => (
                  <BlogComponentBlogItemDiv>
                    <div>
                      <a
                        className="blog-item-link-container"
                        href="/blogs/banddd"
                      >
                        <div className="blog-item-img-container">
                          <img alt="" src={Logo} />
                        </div>
                        <div className="blog-item-text-container">
                          <div className="blog-item-topic-text-container">
                            <div className="blog-topic-text-wrapper">
                              <p>SaaS</p>
                            </div>
                            <div>
                              <div className="blog-item-text-wrapper">
                                <p> Mar 13, 2025</p>
                              </div>
                            </div>
                          </div>
                          <div className="blog-item-text-wrapper ">
                            <h3>
                              Maximizing Your ROI with Effective SaaS Solutions
                            </h3>
                          </div>
                        </div>
                      </a>
                    </div>
                  </BlogComponentBlogItemDiv>
                ))}
              </div>
            </div>
          </div>
        </div>
      </BlogComponentBlogsDiv>
      <Footer />
    </BlogComponentMainDiv>
  );
};

const data = ["", "", "", "", "", ""];
export default BlogComponent;
